module.exports = __webpack_public_path__ + "src/ts/g.frame.modules/instruments_pack/assets/instruments/tablet/tablet.fbx";